<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<!-- {{"ADD" | translate }} {{"GRUPO" | translate }} -->
<form [formGroup]="itemForm" (ngSubmit)="submit()"></form>
<div mat-dialog-content>
  <mat-card class="p-0">
        <form [formGroup]="itemForm" (ngSubmit)="submit()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="tabela" matInput type="text"
                  [formControl]="itemForm.controls['tabela']" placeholder="tabela">
              </mat-form-field>
              <small
                *ngIf="itemForm.controls['tabela'].hasError('required') && itemForm.controls['tabela'].touched"
                class="form-error-msg"> Tabela é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="codigo" matInput type="text"
                  [formControl]="itemForm.controls['codigo']" placeholder="Código">
              </mat-form-field>
              <small *ngIf="itemForm.controls['codigo'].hasError('required') && itemForm.controls['codigo'].touched"
                class="form-error-msg"> codigo é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="indice" matInput type="text"
                  [formControl]="itemForm.controls['indice']" placeholder="indice">
              </mat-form-field>
              <small *ngIf="itemForm.controls['indice'].hasError('required') && itemForm.controls['indice'].touched"
                class="form-error-msg"> índice é obrigatório </small>
            </div>

            <div fxFlex="50" class="pr-1">
              <mat-form-field class="full-width">
                <mat-select matNativeControl placeholder="Tipo de Juro" formControlName="tipo">
                  <mat-option value="PERCENTUAL">1-Percentual</mat-option>
                  <mat-option value="MULTIPLICADOR">2-Multiplicador</mat-option>
                  <mat-option value="DIVISOR">3-Divisor</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="100" class="pr-1">
              <mat-form-field class="full-width">
                <input [imask]="maskUpper" matInput name="descricao" matInput type="text"
                  [formControl]="itemForm.controls['descricao']" placeholder="Descrição">
              </mat-form-field>
              <small *ngIf="itemForm.controls['descricao'].hasError('required') && itemForm.controls['descricao'].touched"
                class="form-error-msg"> Descrição é obrigatório </small>
            </div>

            <div fxFlex="100" class="pr-1">
              <mat-checkbox name="desativado" [formControl]="itemForm.controls['desativado']">Desativado?</mat-checkbox>
            </div>

            <div fxFlex="100" class="mt-1">
              <button mat-raised-button color="primary" [disabled]="itemForm.invalid">{{"SAVE" | translate }}</button>
              <span fxFlex></span>
              <button mat-button color="warn" type="button" (click)="close()">{{"CANCEL" | translate }}</button>
            </div>
            
          </div>
        </form>
  </mat-card>
</div>
